import { type KeyboardEvent, type ReactNode } from 'react';
import { Icon } from '../display';
import classes from './OrderButton.module.css';
import { Column } from './types';

export default function OrderButton({
  children,
  column,
  orderBy,
  onOrderByChange,
}: {
  children: ReactNode;
  column: Column;
  onOrderByChange?: (field: string) => void;
  orderBy?: string;
}) {
  const [field, direction = 'asc'] = (orderBy || '').split('.');
  const isThisField = column.id === field || column.orderBy === field;

  if (column.orderBy === false || !onOrderByChange) {
    return children as any;
  }

  function onClick() {
    const newDirection = isThisField && direction === 'asc' ? 'desc' : 'asc';
    const newField = column.orderBy || column.id;
    onOrderByChange?.(`${newField}.${newDirection}`);
  }

  function onKeyDown(e: KeyboardEvent<HTMLDivElement>) {
    if (e.key === 'Enter' || e.key === ' ') {
      onClick();
    }
  }

  return (
    <div
      className={classes.root}
      onClick={onClick}
      onKeyDown={onKeyDown}
      role="button"
      tabIndex={0}
    >
      {children}
      {isThisField && (
        <Icon
          icon={direction === 'asc' ? 'sort-amount-up-alt' : 'sort-amount-down'}
          sx={{ ml: 1 }}
        />
      )}
    </div>
  );
}
